<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h5>Edición de coordenadas</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-6">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="latitud" placeholder="Escriba una latitud..." v-model="form.latitud">
                        Latitud
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-6">
                <div class="form-field">
                    <input-field vMoney :format="decimal" id="longitud" placeholder="Escriba una longitud..." v-model="form.longitud">
                        Longitud
                    </input-field>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button type="button" @click="guardar" class="btn-success"><i class="fa fa-save"></i><span>Guardar</span></button>
            <button type="button" @click="cancelar" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cancelar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pedidoId: {
            type: String,
            required: false,
            default: ''
        },
        latitud: {
            required: false,
            default: ''
        },
        longitud: {
            required: false,
            default: ''
        }
    },
    data: function () {
        return {
            form: {
                latitud: this.latitud,
                longitud: this.longitud
            },
            decimal: decimalCoordinates
        };
    },
    methods: {
        guardar: function () {
            if (this.form.latitud == '') {
                swal.fire('La latitud es requerida.', 'Aviso', 'warning');
                return;
            }
            if (this.form.longitud == '') {
                swal.fire('La longitud es requerida.', 'Aviso', 'warning');
                return;
            }
            axios.post(url + '/logistica/pedidos/' + this.pedidoId + '/actualizar-coordenadas', this.form).then(() => {
                swal.fire('Las coordenadas fueron actualizadas exitósamente.', 'Realizado', 'success');
                this.$emit('updated');
            }).catch(() => {
                swal.fire('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        cancelar: function () {
            this.$emit('cancelar');
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/EditarCoordenadas.vue